import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';

@Injectable()
export class CustomDatepickerIntlService extends MatDatepickerIntl {

  // @ts-ignore
  get calendarLabel() {
    return this.translateService.instant('a11y.date.calendarLabel');
  }
  // @ts-ignore
  get openCalendarLabel() {
    return this.translateService.instant('a11y.date.openCalendarLabel');
  }
  // @ts-ignore
  get prevMonthLabel() {
    return this.translateService.instant('a11y.date.prevMonthLabel');
  }
  // @ts-ignore
  get nextMonthLabel() {
    return this.translateService.instant('a11y.date.nextMonthLabel');
  }
  // @ts-ignore
  get prevYearLabel() {
    return this.translateService.instant('a11y.date.prevYearLabel');
  }
  // @ts-ignore
  get nextYearLabel() {
    return this.translateService.instant('a11y.date.nextYearLabel');
  }
  // @ts-ignore
  get prevMultiYearLabel() {
    return this.translateService.instant('a11y.date.prevMultiYearLabel');
  }
  // @ts-ignore
  get nextMultiYearLabel() {
    return this.translateService.instant('a11y.date.nextMultiYearLabel');
  }
  // @ts-ignore
  get switchToMonthViewLabel() {
    return this.translateService.instant('a11y.date.switchToMonthViewLabel');
  }
  // @ts-ignore
  get switchToMultiYearViewLabel() {
    return this.translateService.instant('a11y.date.switchToMultiYearViewLabel');
  }

  set calendarLabel(value: string) {}
  set openCalendarLabel(value: string) {}
  set prevMonthLabel(value: string) {}
  set nextMonthLabel(value: string) {}
  set prevYearLabel(value: string) {}
  set nextYearLabel(value: string) {}
  set prevMultiYearLabel(value: string) {}
  set nextMultiYearLabel(value: string) {}
  set switchToMonthViewLabel(value: string) {}
  set switchToMultiYearViewLabel(value: string) {}

  constructor(private translateService: TranslateService) {
    super();
  }
}
